import { BlankScreen } from '@strata/react-page-templates';
import { ErrorToast } from '@strata/react-toast-message';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

import { getReferralById } from 'api/agoraAPI';
import { AppRoutes } from 'services/routes';

const tryToRouteToReferral = async ({ referralId, navigate, location }) => {
    try {
        const referralDetails = await getReferralById({ referralId });
        if (Object.keys(referralDetails).length > 0) {
            navigate(
                {
                    pathname: AppRoutes.referralDetails(referralDetails.payer_id, referralId),
                    hash: location.hash.replace(/^#/, ''),
                },
                {
                    replace: true,
                    state: location.state,
                },
            );
        }
    } catch {
        ErrorToast({ message: 'Referral not found' });
        navigate(AppRoutes.referralsList);
    }
};

export const ReferralRedirect = () => {
    const { referralId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        tryToRouteToReferral({ referralId, navigate, location });
    }, [referralId, navigate, location]);

    return <BlankScreen />;
};
